import { PointAddRequest } from "@1games-ru/region-shared/dist/client/requests/point";
import { useCallback } from "react";
import CreateEntityMpProvider from "@/core/data-provider/data-mp/create-entity/create-entity-mp-provider";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import toast from "@/domains/toasts/helpers/toast";

export default function usePoint() {
  const addPoint = useCallback(async (data?: PointAddRequest) => {
    try {
      const response = await CreateEntityMpProvider.addPoint(data);
      if (response instanceof RpcMpProviderSuccessResponse) {
        toast.success("Точка создана");
        return response.data;
      }
      toast.error("Ошибка создания точки");
      return null;
    } catch (e) {
      console.log(e);
      toast.error("Ошибка создания точки");
      return null;
    }
  }, []);

  const clearPoints = useCallback(async () => {
    try {
      const response = await CreateEntityMpProvider.clearPoints();
      if (response instanceof RpcMpProviderSuccessResponse) {
        toast.success("Точки удалены");
        return response.data;
      }
      toast.error("Ошибка удаления точек");
      console.error(response);
      return false;
    } catch (e) {
      toast.error("Ошибка создания дома");
      console.log(e);
      return false;
    }
  }, []);

  return { addPoint, clearPoints };
}
